var React = require('react');

function SChevronleftmedium22N (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m13.86153,14.89181l-4.28267-4.28266,4.28267-4.28266c.39115-.38982.39224-1.02292.00242-1.41407-.38982-.39115-1.02292-.39224-1.41407-.00242l-.00242.00241-4.98939,4.9894c-.39066.39011-.39111,1.02305-.001,1.41372l.001.001,4.98939,4.98939c.38983.39114,1.02293.3922,1.41407.00237.39114-.38983.3922-1.02293.00237-1.41407l-.00237-.00241Z","fill":"var(--iconFill, #464646)"}));
}

SChevronleftmedium22N.defaultProps = {"id":"ImportedIcons","width":"22","height":"22","viewBox":"0 0 22 22"};

module.exports = SChevronleftmedium22N;

SChevronleftmedium22N.default = SChevronleftmedium22N;
